import { Link } from 'react-router-dom';
import { BalloonEventModel } from 'ts-core';
import { useTranslations } from '../..';

function LinkIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-4 h-4 mr-1 inline-block"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"
            />
        </svg>
    );
}

export function SourcesSection({ event }: { event: BalloonEventModel }) {
    const { translated } = useTranslations();
    const rawProviders = event.allDataSourceProviders;

    // Normalize: API may return a single object or an array
    const providers = Array.isArray(rawProviders)
        ? rawProviders
        : rawProviders && typeof rawProviders === 'object' && 'id' in rawProviders
          ? [rawProviders]
          : [];

    // Only attribute creators that have a public profile to link to (slug is
    // generated on the user's first profile save — never link to /user/null).
    const creator = event.creator?.slug ? event.creator : null;

    if (providers.length === 0 && !creator) {
        return null;
    }

    return (
        <div className="balloon-section sources-section">
            {providers.length > 0 && (
                <>
                    <b>{translated('sources')}</b>
                    <div className="flex flex-col gap-1 mt-1">
                        {providers.map((provider) => (
                            <div key={provider.id} className="flex items-center">
                                {provider.canonicalUrl ? (
                                    <a
                                        href={provider.canonicalUrl}
                                        target="_blank"
                                        style={{color: "var(--color-balloon)"}}
                                        rel="noopener noreferrer"
                                        className="text-balloon hover:underline flex items-center text-sm"
                                    >
                                        <LinkIcon />
                                        {provider.name}
                                    </a>
                                ) : (
                                    <span className="flex items-center text-sm">
                                        <LinkIcon />
                                        {provider.name}
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>
                </>
            )}

            {creator && (
                <div className={`created-by text-sm text-gray-600 ${providers.length > 0 ? 'mt-2' : ''}`}>
                    {translated('created_by')}:{' '}
                    <Link
                        to={`/user/${creator.slug}`}
                        style={{color: "var(--color-balloon)"}}
                        className="hover:underline font-medium"
                    >
                        {creator.name}
                    </Link>
                </div>
            )}
        </div>
    );
}
